// extracted by mini-css-extract-plugin
export default {"container":"PasswordGate_container__hD6cg","form":"PasswordGate_form__y7EuA","error":"PasswordGate_error__j9YVi"};